import { DataMap } from '@grapecity/wijmo.grid'

import { ListItem } from '../utility/list-item'

// NOTE: Make sure this stays in sync with the server-side enum (PendingChangeOrderPricingMethod.cs).
export enum PendingChangeOrderPricingMethod {
    TM = 0,
    UnitPrice = 1,
    LumpSum = 2,
}

const labels: Record<PendingChangeOrderPricingMethod, string> = {
    [PendingChangeOrderPricingMethod.TM]: 'T&M',
    [PendingChangeOrderPricingMethod.UnitPrice]: 'Unit Price',
    [PendingChangeOrderPricingMethod.LumpSum]: 'Lump Sum',
}

export function pendingChangeOrderPricingMethodDisplay(value: PendingChangeOrderPricingMethod | undefined): string {
    const v = value ?? PendingChangeOrderPricingMethod.TM
    return labels[v] ?? labels[PendingChangeOrderPricingMethod.TM]
}

/** List items for Wijmo combo boxes (value = enum, display = label). Order matches the enum values 0..n. */
export function createPendingChangeOrderPricingMethodListItems(): ListItem<PendingChangeOrderPricingMethod>[] {
    return [
        new ListItem<PendingChangeOrderPricingMethod>(
            PendingChangeOrderPricingMethod.TM,
            labels[PendingChangeOrderPricingMethod.TM],
        ),
        new ListItem<PendingChangeOrderPricingMethod>(
            PendingChangeOrderPricingMethod.UnitPrice,
            labels[PendingChangeOrderPricingMethod.UnitPrice],
        ),
        new ListItem<PendingChangeOrderPricingMethod>(
            PendingChangeOrderPricingMethod.LumpSum,
            labels[PendingChangeOrderPricingMethod.LumpSum],
        ),
    ]
}

/** DataMap for Wijmo grids (same key/display pairing as @see createPendingChangeOrderPricingMethodListItems). */
export function createPendingChangeOrderPricingMethodDataMap(): DataMap {
    return new DataMap(createPendingChangeOrderPricingMethodListItems(), 'value', 'display')
}
